import useEventCallback from '@unifyapps/hooks/useEventCallback';
import type { OnActionArgs, OnActionType } from '../../../../context/ActionsProvider/context';
import { oldEvaluateExpression } from '../../../../utils/evaluateExpression';
import { useGetShouldEvaluateResult } from '../../../computeContext/useGetShouldEvaluateResult';
import { useReportActionError } from '../../../useReportActionError';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

export const useEvalJS = () => {
  const reportActionError = useReportActionError();
  const shouldEvaluateResult = useGetShouldEvaluateResult();

  const onEvalJS: OnActionType = useEventCallback(
    ({ action, instanceId, blockId }: OnActionArgs) => {
      const script = action.payload?.script as string;
      if (script) {
        oldEvaluateExpression({
          context: {
            console: window.console,
          },
          expression: script,
          shouldEvaluateResult,
          // evalJS is a deliberate "run my JS" action — the one shared-path surface
          // that keeps the permissive context now that bindings default to readOnly.
          evalMode: 'readWrite',
          onError: (error) => {
            reportActionError({
              source: 'runScript',
              error,
              instanceId,
              blockId,
              expression: script,
            });
          },
        });
      }
      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
  );

  return { onEvalJS };
};
